import { render, staticRenderFns } from "./agentList.vue?vue&type=template&id=72739018&scoped=true"
import script from "./agentList.vue?vue&type=script&lang=js"
export * from "./agentList.vue?vue&type=script&lang=js"
import style0 from "./agentList.vue?vue&type=style&index=0&id=72739018&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72739018",
  null
  
)

export default component.exports